import { render, staticRenderFns } from "./BindsCheckIcon.vue?vue&type=template&id=96534714&"
import script from "./BindsCheckIcon.vue?vue&type=script&lang=js&"
export * from "./BindsCheckIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports